import { useEffect } from 'react';
import Icon from '../AppIcon';

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'تأكيد الحذف',
  message = 'هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.',
  confirmText = 'حذف',
  cancelText = 'إلغاء',
  loading = false,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onCancel}
      />

      <div
        className="relative w-full max-w-sm p-8 rounded-3xl"
        style={{
          backgroundColor: '#F9F7F2',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
          border: '1px solid rgba(197, 160, 89, 0.15)',
        }}
      >
        <div className="flex flex-col items-center text-center space-y-5">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center"
            style={{ backgroundColor: 'rgba(220, 38, 38, 0.08)' }}
          >
            <Icon name="AlertTriangle" size={26} color="#DC2626" />
          </div>

          <h3
            className="text-xl"
            style={{ fontFamily: 'Aref Ruqaa, serif', color: '#2C2B29' }}
          >
            {title}
          </h3>

          <p
            className="text-sm leading-relaxed"
            style={{ fontFamily: 'Amiri, serif', color: '#6B7280' }}
          >
            {message}
          </p>

          <div className="flex gap-3 w-full pt-2">
            <button
              onClick={onCancel}
              disabled={loading}
              className="flex-1 py-3 rounded-full text-sm transition-all duration-300 hover:bg-[rgba(197,160,89,0.1)]"
              style={{
                fontFamily: 'Amiri, serif',
                color: '#6B7280',
                border: '1px solid rgba(197, 160, 89, 0.2)',
              }}
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              disabled={loading}
              className="flex-1 py-3 rounded-full text-sm text-white transition-all duration-300 disabled:opacity-50"
              style={{
                fontFamily: 'Amiri, serif',
                backgroundColor: '#DC2626',
              }}
            >
              {loading ? '...' : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
